'use client';

import { useLanguageStore, type Language } from '../stores/languageStore';
import { useApiClient } from '../contexts/ApiContext';
import { UpdateLanguageLanguageCodeEnum } from '../services/generated';

interface UseLanguageReturn {
  language: Language;
  changeLanguage: (lang: Language) => void;
}

export const useLanguage = (): UseLanguageReturn => {
  const language = useLanguageStore((state) => state.language);
  const setLanguage = useLanguageStore((state) => state.setLanguage);
  const apiClient = useApiClient();

  const changeLanguage = (lang: Language) => {
    // Update local state first for immediate UI response
    setLanguage(lang);

    // Sync with backend (fire and forget, don't block UI)
    apiClient.api
      .profileSettingsControllerUpdateLanguage({
        languageCode: lang as UpdateLanguageLanguageCodeEnum,
      })
      .catch((error: unknown) => {
        console.error('Failed to sync language with backend:', error);
      });
  };

  return {
    language,
    changeLanguage,
  };
};

export type { Language };
